import axios from 'axios';

export const state = {
    agreedPosts: {}
};

export const mutations = {
    SET_AGREED_POSTS (state, newValue) {
        state.agreedPosts = newValue;
    },
    CLEAR (state) {
        state.agreedPosts = {};
    }
};

export const getters = {
    hasAgreedPostsData (state) {
        return Object.keys(state.agreedPosts).length > 0;
    }
};

export const actions = {
    async getAgreedPostsData({ commit }, type = '') {
            const agreedPosts = await axios.get(`${type}/agreed-post`);
            const notifications = await axios.get('/notification/agreed-post');
            attachNotifications(agreedPosts.data, notifications.data);
            commit('SET_AGREED_POSTS', agreedPosts.data);
    }
};

// attach notifications to responding campaign agreement
function attachNotifications (agreedPosts, notifications) {
    notifications.forEach( notification => {
        Object.keys(agreedPosts).forEach( key => {
            agreedPosts[key].forEach( agreement => {
                if ( agreement._id === notification.sourceable_id) {
                    if (!agreement.notifications) {
                        agreement.notifications = [];
                    }
                    agreement.notifications.push(notification);
                }
            });
        });
    });
}